import { render, staticRenderFns } from "./ManageDonor.vue?vue&type=template&id=77fb238b"
import script from "./ManageDonor.vue?vue&type=script&lang=js"
export * from "./ManageDonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports